import { render, staticRenderFns } from "./FixToDoSCList.vue?vue&type=template&id=6863c68e&"
import script from "./FixToDoSCList.vue?vue&type=script&lang=js&"
export * from "./FixToDoSCList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports